(function () {
  'use strict';

  if (window.FellinoraCommunityBenefitsLoaded) {
    return;
  }

  window.FellinoraCommunityBenefitsLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setDelays(section) {
    section.querySelectorAll('[data-fcb-stagger]').forEach(function (item) {
      var delay = Number(item.getAttribute('data-fcb-delay')) || 0;
      item.style.setProperty('--fcb-delay', delay + 'ms');
    });
  }

  function reveal(section) {
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      section.classList.add('fcb-is-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        section.classList.add('fcb-is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.2
    });

    observer.observe(section);
  }

  function initSection(section) {
    if (!section) {
      return;
    }

    setDelays(section);
    reveal(section);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-fcb-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
